const mfaAndResetActivationCodeEntryTemplate = `
<!---------- BEGIN Error alert ---------->
<div id="form-alert" role="alert">
    <alert-message type="alert" ng-if="formOnError">
        {{"generalError"| translate }}&nbsp;
        <span class="sr-only">{{"focusInputMessage"| translate }}</span>
    </alert-message>
</div>
<!---------- END Error alert ---------->

<!---------- BEGIN form ---------->
<div class="form-group" data-ng-class="getFormGroupClass()">
    <label for="verification_codeInput">{{"pleaseEnterCode" | translate}}</label>

    <input type="tel" class="form-control" 
        id="verification_codeInput"
        name="verificationCode"
        auto-focus
        data-ng-required="true"
        data-activationcode-validator
        data-mask="99999999"
        data-mask-restrict="accept"
        data-mask-clean="true"
        maxlength="8"
        data-ng-model="verification.verificationCode"
        data-ng-model-options="{ updateOn: 'blur', allowInvalid: true }"
        ng-blur="activationCodeChange()"
        aria-invalid="{{formOnError}}"
        aria-describedby="verificationCodeRules verificationCodeError"/>
    
    <!---------- BEGIN form errors ---------->
    <div id="verificationCodeError" aria-live="assertive" aria-atomic="true" ng-if="formOnError" sr-order="2">
        <alert-message>
            <!-- ERROR: Required error. -->
            <p ng-if="getFieldError('verificationCode').required" class="error-message-content">
                {{"verificationcodeRequired" | translate }}
            </p>
            <!-- ERROR: Default Invalid error. -->
            <p ng-if="!getFieldError('verificationCode').required && showFormDefaultError" class="error-message-content">
                {{"verificationCodeEightDigits" | translate }}
            </p>
            <!-- TODO: this should be a directive -->
            <p ng-if="verificationMessage" class="error-message-content">
                {{verificationMessage}}
            </p>
            <!-- ERROR: Server errors. -->
            <p ng-if="mfa.errorMessage"
                class="error-message-content"
                translate="{{mfa.errorMessage}}"
                translate-default="We are unable to send verification codes at this time. Please try again. Contact a Participant Services Representative if the problem continues.">
            </p>
        </alert-message>
    </div>
    <!---------- END form errors ---------->
</div>
<!---------- END form ---------->

<!---------- BEGIN Screen Reader Support ---------->
<span class="sr-only" id="verificationCodeRules">
    {{"pleaseEnterCodeDescription" | translate }}.
</span>
<!---------- END Screen Reader Support ---------->
`;
export default mfaAndResetActivationCodeEntryTemplate;
